import { render, staticRenderFns } from "./WeightlossReferralStep.vue?vue&type=template&id=eb04892e"
import script from "./WeightlossReferralStep.vue?vue&type=script&lang=js"
export * from "./WeightlossReferralStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports